import React, { useEffect, useState } from "react";
import "./CustomersPage.css";

function CustomersPage() {
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchEmail, setSearchEmail] = useState("");

  useEffect(() => {
    fetch("https://www.actrofiteinfotech.com/rootservices/dashboard/get_all_users.php")
      .then(async (res) => {
        const text = await res.text();
        try {
          const data = JSON.parse(text);
          if (data.success) {
            const sortedUsers = data.data.sort((a, b) => b.id - a.id);
            setUsers(sortedUsers);
            setFilteredUsers(sortedUsers);
          } else {
            setError("Failed to fetch users");
          }
        } catch (e) {
          console.error("Invalid JSON from server:", text);
          setError("Server returned invalid JSON. Check backend.");
        }
      })
      .catch((err) => {
        console.error("Fetch error:", err);
        setError("Could not connect to server");
      })
      .finally(() => setLoading(false));
  }, []);

  // Filter users by email whenever searchEmail changes
  useEffect(() => {
    if (!searchEmail.trim()) {
      setFilteredUsers(users);
    } else {
      setFilteredUsers(
        users.filter((user) =>
          user.email?.toLowerCase().includes(searchEmail.toLowerCase())
        )
      );
    }
  }, [searchEmail, users]);

  if (loading) return <p className="loading-text">Loading customers...</p>;
  if (error) return <p className="error-text">{error}</p>;

  return (
    <div className="customers-container">
      <h2 className="customers-title">Registered Customers</h2>

      {/* Search Bar */}
      <div className="search-bar">
        <input
          type="text"
          placeholder="Search by Email ID..."
          value={searchEmail}
          onChange={(e) => setSearchEmail(e.target.value)}
        />
      </div>

      <div className="customers-grid">
        {filteredUsers.length === 0 ? (
          <p className="no-data">No users found</p>
        ) : (
          filteredUsers.map((user) => (
            <div key={user.id} className="customer-card">
              <div className="customer-header">
                {user.profile_pic ? (
                  <img src={user.profile_pic} alt={user.name} className="profile-pic" />
                ) : (
                  <div className="profile-placeholder">{user.name?.charAt(0)}</div>
                )}
                <div>
                  <h3>{user.name || "Unnamed"}</h3>
                  <p className="customer-id">ID: {user.id}</p>
                </div>
              </div>

              <div className="customer-info">
                <p><strong>Email:</strong> {user.email}</p>
                <p><strong>Phone:</strong> {user.phone}</p>
                <p><strong>Alt. Phone:</strong> {user.alternate_phone || "N/A"}</p>
                <p><strong>Gender:</strong> {user.gender || "N/A"}</p>
                <p><strong>City:</strong> {user.city}</p>
                <p><strong>State:</strong> {user.state}</p>
                <p><strong>Pincode:</strong> {user.pincode}</p>
              </div>

              <div className="customer-footer">
                <span>📅 {user.created_at}</span>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default CustomersPage;
